export enum VisaResult {
  A = 'Address matches, ZIP code does not match.',
  B = 'Street addresses match for international transaction. Postal code not verified due to incompatible formats. (Acquirer sent street address and postal code.)',
  C = 'Street address and postal code not verified for international transaction due to incompatible formats. (Acquirer sent street address and postal code.)',
  D = 'Street addresses and postal codes match for international transaction.',
  E = 'Error response for Merchant Category Code.',
  F = 'Address does compare and five-digit ZIP codes does compare (UK only)',
  G = 'Address information is unavailable for international transaction; non-AVS participant.',
  I = 'Address information not verified for international transaction.',
  M = 'Street addresses and postal codes match for international transaction.',
  N = 'Address and ZIP code do not match.',
  P = 'Postal codes match for international transaction. Street address not verified due to incompatible formats. (Acquirer sent street address and postal code.)',
  R = 'Retry; system unavailable or timed out.',
  S = 'Service not supported by issuer.',
  U = 'Address information is unavailable; domestic transactions.',
  W = 'Nine-digit ZIP code matches, but address does not match.',
  X = 'Exact match, address, and nine-digit ZIP code match.',
  Y = 'Address and five-digit ZIP code match.',
  Z = 'Five-digit ZIP code matches, but address does not match.',
  '05' = 'Invalid AVS response (from VISA).',
  '09' = 'Address Verification Data contains EDIT ERROR.',
  '00' = 'Issuer has chosen not to perform Address Verification for an authorization that was declined.'
}

export enum MastercardResult {
  A = 'Address matches, postal code does not.',
  N = 'Neither address nor postal code matches.',
  R = 'Retry, system unable to process.',
  S = 'AVS currently not supported.',
  U = 'No data from issuer/Authorization System.',
  W = 'For U.S. addresses, nine-digit postal code matches, address does not; for address outside the U.S., postal code matches, address does not.',
  X = 'For U.S. addresses, nine-digit postal code and address matches; for addresses outside the U.S., postal code and address match.',
  Y = 'For U.S. addresses, five-digit postal code and address matches.',
  Z = 'For U.S. addresses, five-digit postal code matches, address does not.',
  '05' = 'Invalid AVS response (from MasterCard)',
  '09' = 'Address Verification Data contains EDIT ERROR.',
  '00' = 'Issuer has chosen not to perform Address Verification for an authorization that was declined.'
}
